import { render, staticRenderFns } from "./Atribucion.vue?vue&type=template&id=3c3f65ec"
import script from "./Atribucion.vue?vue&type=script&lang=js"
export * from "./Atribucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports